import React from 'react';
import classNames from 'classnames';
import { string, arrayOf, object, shape, func, number } from 'prop-types';
import PaginationLinks from '../PaginationLinks/PaginationLinks';

import css from './TableComponent.css';

const TableComponent = props => {
  const {
    className,
    rootClassName,
    renderItem,
    data,
    pagination,
    keyExtractor,
    pageSearchParams,
  } = props;

  const { totalPages } = pagination;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.body}>
        {data.map((item, index) => (
          <div className={css.row} key={keyExtractor(item, index)}>
            {renderItem(item, index)}
          </div>
        ))}
      </div>
      <div className={css.footer}>
        <div className={css.pagination}>
          <PaginationLinks
            pageName="AdminManageTransactionsPage"
            // pagePathParams={}
            pageSearchParams={pageSearchParams}
            pagination={pagination}
          />
        </div>
      </div>
    </div>
  );
};

TableComponent.defaultProps = {
  className: null,
  rootClassName: null,
  data: [],
  pagination: {
    totalPages: 0,
  },
  renderItem: () => null,
  keyExtractor: (_, index) => `${index}`,
};

TableComponent.propTypes = {
  className: string,
  rootClassName: string,
  data: arrayOf(object),
  pagination: shape({
    totalPages: number,
  }),
  renderItem: func,
  keyExtractor: func,
};

export default TableComponent;
